import React from 'react';
import { Tooltip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { observer } from 'mobx-react';
import { stringify } from '@jbrowse/core/util';
var useStyles = makeStyles()({
  guide: {
    pointerEvents: 'none',
    height: '100%',
    width: 1,
    position: 'absolute',
    zIndex: 10
  }
});
function VerticalGuide(_ref) {
  var model = _ref.model,
    coordX = _ref.coordX;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  return React.createElement(Tooltip, {
    open: true,
    placement: "top",
    title: stringify(model.pxToBp(coordX)),
    arrow: true
  }, React.createElement("div", {
    className: classes.guide,
    style: {
      left: coordX,
      background: 'red'
    }
  }));
}
export default observer(VerticalGuide);